/**
 * Retells' one install record, for the shared install offer in @bindery/ui.
 *
 * The policy, the early `beforeinstallprompt` capture and the hook live in
 * the package (`@bindery/ui/lib/install-state`, `lib/install-prompt`,
 * `hooks/use-install-offer`); what is this app's is the key and the storage
 * handle, so they are named here, once. main.tsx hands this object to
 * `watchInstallability` before hydration and ./InstallOffer.tsx hands the
 * same one to `useInstallOffer`, which is what keeps the capture's
 * suppression decision and the panel reading one record.
 *
 * The key is unchanged from when the module lived in this directory
 * (`retells.install.v1`), so a returning visitor's counts carry over.
 */
import { createInstallStateStore } from "@bindery/ui/lib/install-state";
import { resolveLocalStorage, storageKey } from "../storage";

export const installState = createInstallStateStore(
  storageKey("install.v1"),
  resolveLocalStorage,
);
